import React, { Fragment } from 'react';

import useSelectionsExistingSelections from './UseSelectionsExistingSelections';

import ExistingSelectionsGrid from '../components/grids/ExistingSelectionsGrid';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SelectionsExistingSelections = () => {
  const {
    isLoading,
    gridData,
    meetName,
    onEditSelectionClicked,
    onDeleteSelectionClicked,
    onBackToSearchClicked
  } = useSelectionsExistingSelections();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{meetName} Existing Selections</Headings.H3>
        </div>
      </div>
      <div className='row usas-extra-top-margin'>
        <div className="col-xs-12">
          <button className={global.BackToSearchButton}
            type="button"
            onClick={onBackToSearchClicked}>
            <LeftArrowIcon />  {'Back To Meet Participant Selection Search'}
          </button>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <ExistingSelectionsGrid
            gridData={gridData}
            isLoading={isLoading}
            onEditSelectionClicked={onEditSelectionClicked}
            onDeleteSelectionClicked={onDeleteSelectionClicked} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default SelectionsExistingSelections;